import _ from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import TrueUpInvoiceContainer from "../../containers/accounting/TrueUpInvoice";
import TrueUpInvoiceForPdf from "../../components/TrueUpInvoiceForPdf";

const styles = () => {
	return {
		root : {
			position : 'absolute',
			backgroundColor : 'white',
			height: '100%',
			width : '100%',
		},
	};
};

class TrueUpInvoice extends Component {

	constructor(props){
		super(props);
		const trueUpInvoiceId = _.get(this.props, ['match', 'params', 'trueUpInvoiceId']);
		const securityHash = _.get(this.props, ['match', 'params', 'securityHash']);

		this.state = {
			trueUpInvoiceId : (trueUpInvoiceId) ? parseInt(trueUpInvoiceId, 10) : undefined,
			securityHash,
			errors : [],
		};
	}

	componentDidMount () {
		//- Only used for updates
		const { publicGetTrueUpInvoice, trueUpInvoice} = this.props;
		const { trueUpInvoiceId, securityHash } = this.state;
		if (trueUpInvoice) { return; }

		publicGetTrueUpInvoice({
			params : {
				trueUpInvoiceId,
				securityHash,
				includeQuickbooksCustomers : true,
				includeQuickbooksTerms : true,
			},
			callback : (err, r) => {
				if (err) { return this.setState({ errors : [err] }); }
				const trueUpInvoice = _.get(r, ['collections', 'trueUpInvoiceCollection', 0]);
				if (!trueUpInvoice) { return {errors : ['Missing trueUp invoice.']}; }
				return this.setState({ trueUpInvoice });
			}
		});
	}

	render() {
		const {
			classes,
			trueUpInvoice,
			quickbooksCustomerMap,
			bulkCustomerMap,
			quickbooksTermMap,
		} = this.props;

		const {
			errors,
		} = this.state;

		if (errors.length) {
			return (<div>
				<div>Encountered an error when retrieving the invoice</div>
				{errors.map((error,i) => {
					return (<div key={i}>{error}</div>);
				})};
			</div>);
		}

		if (!trueUpInvoice) {
			return (<div>Fetching trueUp invoice...</div>);
		}

		return (<div className={classes.root}>
			<TrueUpInvoiceForPdf
				trueUpInvoice={trueUpInvoice}
				quickbooksCustomerMap={quickbooksCustomerMap}
				quickbooksTermMap={quickbooksTermMap}
				bulkCustomerMap={bulkCustomerMap}
			/>
		</div>);
	}
}

TrueUpInvoice.propTypes = {
	classes: PropTypes.object.isRequired,
	showErrors : PropTypes.func,

	//- Batch
	publicGetTrueUpInvoice : PropTypes.func,
	trueUpInvoice : PropTypes.object,
	quickbooksCustomerMap : PropTypes.object,
	quickbooksTermMap : PropTypes.object,
	bulkCustomerMap : PropTypes.object,
};

export default _.flow([
	withStyles(styles),
	TrueUpInvoiceContainer,
])(TrueUpInvoice);

